import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
// particle config
//import { particleConfig } from '../../components/public/homepage-hero/particle-config';
//import { generateApiUrl, generateiHrAuthHeaders } from '../../features/podcast-submit/utils'

//const apiUrl = generateApiUrl('portalAccountSlice.js');

// Google Recaptcha Client Key
const GRECAPTCHAKEY = process.env.REACT_APP_GRECAPTCHAKEY;
//console.debug('GRECAPTCHAKEY', GRECAPTCHAKEY);

// construct API Endpoint
// popular podcasts
const ihrApi_podcastCategory = 'https://us.api.iheart.com/api/v3/podcast/categories/';

const initialState = {
  counter: {
    value: 0,
  },
  uiState: {
    fixed: null,
  },
  heroPodcastsCategory: {
    loading: false,
    categoryID: '',
    limit: 10,
    categoryData: null,
    particleData: null,
    scrollingData: null,
    error: null,
  },
  recaptcha: {
    sitekey: GRECAPTCHAKEY,
    valid: false,
    value: null,
    error: null,
  },
}

const shuffle = (array) => { 
  //console.debug('shuffle', array);
  const newArray = JSON.parse(JSON.stringify(array));
  return newArray.sort(() => Math.random() - 0.5); 
};

export const fetchHeroPodcastCategoryIfNeeded = createAsyncThunk(
  'public/fetchHeroPodcastCategoryIfNeeded',
  async (args, { getState, rejectWithValue, }) => {
    const hpcState = JSON.parse(window.localStorage.getItem('hpcState'));
    //console.debug('hpcState', hpcState);
    if (hpcState) {
      return {categoryData: hpcState.categoryData, scrollingData: hpcState.scrollingData, scrollingDataShuffled: hpcState.scrollingDataShuffled }
    } else {
      try {
        const requestOptions = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          }
        };
        const res = await fetch(ihrApi_podcastCategory + args.categoryID + '?limit='+ args.limit, requestOptions)
          .then((data) => data.json())
          .then((json) => {
            // limit returned results
            const limitItems = json.podcasts.slice(0, args.limit).map((podcast) => { return podcast });
            let scrollingData = [];
            // for each item, convert to particle object format
            for (const limitItem of limitItems) {
              const newParticleObject = {
                src: 'https://i.iheart.com/v3/catalog/podcast/'+ limitItem.id +'?ops=quality(80),cover(100,100),blur(2)',
                height: 80,
                width: 80
              };
              scrollingData = [...scrollingData, newParticleObject]
            }
            const scrollingDataShuffled = shuffle(scrollingData);
            

            // store for later
            const hpcState = {
              loading: false,
              categoryID: args.categoryID,
              limit: args.limit,
              categoryData: limitItems,
              scrollingData,
              scrollingDataShuffled,
            }
            window.localStorage.setItem('hpcState', JSON.stringify(hpcState));
            return {
              categoryData: limitItems, 
              scrollingData, 
              scrollingDataShuffled
            }
          })
        return res
      } catch (err) {
        //console.debug('fetchHeroPodcastCategoryIfNeeded - err', err);
        return rejectWithValue(err.response.data)
      }
    }
})

export const publicSlice = createSlice({
  name: 'public',
  initialState,
  reducers: {
    uiStateSetFixed: (state, action) => {
      state.uiState.fixed = action.payload
    },
    setRecaptcha: (state, action) => {
      state.recaptcha.valid = action.payload.error ? false : true
      state.recaptcha.value = action.payload.value ? action.payload.value : null
      state.recaptcha.error = action.payload.error ? true : false
    },
  },
  extraReducers: {
    [fetchHeroPodcastCategoryIfNeeded.pending]: (state, { payload, meta }) => {
      state.heroPodcastsCategory.loading = true
      state.heroPodcastsCategory.categoryID = meta.arg.categoryID ? meta.arg.categoryID : ''
      state.heroPodcastsCategory.limit = meta.arg.limit ? meta.arg.limit : 10
    },
    [fetchHeroPodcastCategoryIfNeeded.fulfilled]: (state, { payload, meta }) => {
      state.heroPodcastsCategory.loading = false
      state.heroPodcastsCategory.categoryData = payload.categoryData ? payload.categoryData : false
      state.heroPodcastsCategory.scrollingData = payload.scrollingData ? payload.scrollingData : false
      state.heroPodcastsCategory.scrollingDataShuffled = payload.scrollingDataShuffled ? payload.scrollingDataShuffled : false
    },
    [fetchHeroPodcastCategoryIfNeeded.rejected]: (state) => {
      state.heroPodcastsCategory.loading = false
      state.heroPodcastsCategory.error = true
    },
  },
})

export const { uiStateSetFixed, setRecaptcha, } = publicSlice.actions
export const selectPublic = (state) => state.public;
export const publicReducer = publicSlice.reducer
